import moment from "moment";
import request from "./axios";

function sales(params) {
  return request({
    method: "get",
    url: `/reports/sales`,
    params: params
  });
}

function funnels(params) {
  if (params.filter.start_date)
    params.start_date = moment(params.filter.start_date).toDate();
  if (params.filter.end_date)
    params.end_date = moment(params.filter.end_date).toDate();
  params.completed = params.filter.completed;
  params.date_field = params.filter.date_field;
  params.sale_made_by = params.filter.sale_made_by;

  params.business_stream = params.filter.business_stream;
  params.booking_from = params.filter.booking_from;
  params.venue = params.filter.venue;

  params.region = params.filter.region;

  delete params.filter;

  return request({
    method: "get",
    url: `/reports/funnels`,
    params: params
  });
}

function tcsReasons(params) {
  if (params.filter.start_date)
    params.start_date = moment(params.filter.start_date).toDate();
  if (params.filter.end_date)
    params.end_date = moment(params.filter.end_date).toDate();
  params.completed = params.filter.completed;
  params.date_field = "tcs_at";
  params.sale_made_by = params.filter.sale_made_by;
  params.tcs_assigned_to = params.filter.tcs_assigned_to;

  params.business_stream = params.filter.business_stream;
  params.booking_from = params.filter.booking_from;
  params.venue = params.filter.venue;

  params.region = params.filter.region;

  delete params.filter;

  return request({
    method: "get",
    url: `/reports/tcs_reasons`,
    params: params
  });
}

function confirmationCallScores(params) {
  if (params.filter.start_date)
    params.start_date = moment(params.filter.start_date).toDate();
  if (params.filter.end_date)
    params.end_date = moment(params.filter.end_date).toDate();
  params.user_email = params.filter.user_email;

  delete params.filter;

  return request({
    method: "get",
    url: `/reports/confirmation_call_scores`,
    params: params
  });
}

function downloadTranscripts(params) {
  const query = {};
  if (params.filter.start_date)
    query.start_date = moment(params.filter.start_date).toDate();
  if (params.filter.end_date)
    query.end_date = moment(params.filter.end_date).toDate();
  query.tcs_assigned_to = params.filter.tcs_assigned_to;

  return request({
    method: "get",
    url: `/reports/download_transcripts`,
    params: query
  });
}

function salesPersonResults(params) {
  if (params.filter.start_date)
    params.start_date = moment(params.filter.start_date).toDate();
  if (params.filter.end_date)
    params.end_date = moment(params.filter.end_date).toDate();
  params.date_field = "tcs_at";
  // Opt-in flag: only the Deal Comments report sets this to also pull in follow-up
  // closes. Sales Person Results omits it and keeps its appointment-cohort funnel.
  if (params.filter.include_followup_closes)
    params.include_followup_closes = true;

  delete params.filter;

  return request({
    method: "get",
    url: `/reports/sales_person_results`,
    params: params
  });
}

function daysBeforeSeminar(params) {
  if (params.filter.start_date)
    params.start_date = moment(params.filter.start_date).toDate();
  if (params.filter.end_date)
    params.end_date = moment(params.filter.end_date).toDate();
  params.date_field = params.filter.date_field;

  params.venue = params.filter.venue;
  params.region = params.filter.region;

  delete params.filter;

  return request({
    method: "get",
    url: `/reports/days_booked_before_seminar`,
    params: params
  });
}

function bookedTCSBySalesPerson() {
  return request({
    method: "get",
    url: `/reports/tcs_booked_by_sales_person`
  });
}

function bulkMessages(params) {
  return request({
    method: "get",
    url: `/reports/bulk_messages`,
    params: params
  });
}

function deadDeals(params) {
  return request({
    method: "get",
    url: `/reports/dead_deals`,
    params: params
  });
}

function singleParentAttending(params) {
  if (params.filter && params.filter.start_date)
    params.start_date = moment(params.filter.start_date).toDate();
  if (params.filter && params.filter.end_date)
    params.end_date = moment(params.filter.end_date).toDate();

  delete params.filter;

  return request({
    method: "get",
    url: `/reports/single_parent_attending`,
    params: params
  });
}

function daysBeforeTCS(params) {
  if (params.filter.start_date)
    params.start_date = moment(params.filter.start_date).toDate();
  if (params.filter.end_date)
    params.end_date = moment(params.filter.end_date).toDate();
  params.date_field = params.filter.date_field;

  params.venue = params.filter.venue;
  params.region = params.filter.region;

  delete params.filter;

  return request({
    method: "get",
    url: `/reports/days_booked_before_tcs`,
    params: params
  });
}

function venues() {
  return request({
    method: "get",
    url: `/reports/venues`
  });
}

const ReportsService = {
  sales,
  funnels,
  venues,
  tcsReasons,
  daysBeforeSeminar,
  daysBeforeTCS,
  bookedTCSBySalesPerson,
  salesPersonResults,
  bulkMessages,
  deadDeals,
  singleParentAttending,
  confirmationCallScores,
  downloadTranscripts
};

export default ReportsService;
